import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'

import { formatURI } from '../../../api/common/utils'

import TwitterIcon from '../icon/twitter-outline.svg'

export const Share = (url) => {
  const shareURL = 'https://twitter.com'
  const sharePath = '/intent/tweet'
  const shareQuery = {
    url: url
  }
  if (typeof window !== 'undefined') {
    shareQuery.url = window.location.origin + shareQuery.url
  }

  const newWindow = window.open(
    formatURI(shareURL, sharePath, shareQuery), '_blank'
  )
  newWindow.focus()
}

const ShareOnTwitter = ({ url, outline = false, ...attrs }) => {
  const handleShare = () => {
    Share(url)
  }

  attrs.className = classNames(
    attrs.className,
    [
      'flex',
      'fex-row',
      'items-center',
      'cursor-pointer'
    ]
  )

  return <div
    {...attrs}
    onClick={handleShare}>
    <div
      className={
        classNames([
          outline ? '' : 'mr-4',
          'cursor-pointer',
          outline ? 'text-black' : 'text-white'
        ])
      }
      style={{
        width: '2rem',
        height: '2rem',
        padding: '0.25rem',
        backgroundColor: outline ? '' : '#00ACED'
      }}>
      <TwitterIcon
        width={24}
        height={24} />
    </div>
    {
      outline
        ? null
        : <Typography>
          Twitter
        </Typography>
    }
  </div>
}

ShareOnTwitter.propTypes = {
  url: PropTypes.string,
  outline: PropTypes.bool
}

export default ShareOnTwitter
